import {LIMPAR_TRECHOS_RESERVAS_ITINERARIO} from '../types';

export default function limparTrechosReservasItinerario () {
    return {
        type: LIMPAR_TRECHOS_RESERVAS_ITINERARIO
    }
}
